import React, { useState, useEffect, useRef } from 'react';
import {
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Input,
  Form,
  FormGroup,
  FormText,
  Label,
  FormFeedback,
  Col,
  Row,
} from 'reactstrap';
import axiosAdapter from '../../utils/Adapters';
import './EmailSubscription.scss';
import { sanitizedHTML } from '../../utils/Helper';
import config from '../../config';
import {
  getLocationCode,
  getLocationIP,
  verifyTencent,
  sendSubscription,
  verifyGoogle,
} from './VerifyUtils/VerifyUtils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { countryList } from './VerifyUtils/countryCode';

const EmailSubscription = (props) => {
  const { curLang, emailRules, selectEmail } = props;

  //state
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');
  const [email, setEmail] = useState(selectEmail);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [countrycode, setCountrycode] = useState('');
  const [dTFlag, setDTFlag] = useState(false);
  const [emailInvalid, setEmailInvalid] = useState(false);
  const [firstNameInvalid, setFirstNameInvalid] = useState(false);
  const [lastNameInvalid, setLastNameInvalid] = useState(false);
  const [countryInvalid, setCountryInvalid] = useState(false);
  const [isClickConfirm, setIsClickConfirm] = useState(false);
  const bodyMaskRef = useRef(null);

  const termsText = {
    sc: '请勾选条款',
    en: 'Please check terms.',
    tc: '請勾選條款',
  };

  const externalapp = config.epcAppId;
  //Fn
  const handleEmailChange = (e) => {
    const value = e.target.value;
    setEmail(value);
    if (emailRules.test(value)) {
      setEmailInvalid(false);
    } else {
      setEmailInvalid(true);
    }
  };

  const handleFirstNameChange = (e) => {
    const value = e.target.value;
    setFirstName(value);
    if (value.trim() !== '') {
      setFirstNameInvalid(false);
    } else {
      setFirstNameInvalid(true);
    }
  };

  const handleLastNameChange = (e) => {
    const value = e.target.value;
    setLastName(value);
    if (value.trim() !== '') {
      setLastNameInvalid(false);
    } else {
      setLastNameInvalid(true);
    }
  };

  const handleCountryChange = (e) => {
    const value = e.target.value;
    setCountrycode(value);
    if (value !== '') {
      setCountryInvalid(false);
    } else {
      setCountryInvalid(true);
    }
  };

  const validationInput = () => {
    let isValid = true;
    if (!email.includes('@')) {
      setEmailInvalid(true);
      isValid = false;
    }
    if (firstName.trim() === '') {
      setFirstNameInvalid(true);
      isValid = false;
    }
    if (lastName.trim() === '') {
      setLastNameInvalid(true);
      isValid = false;
    }
    if (countrycode === '') {
      setCountryInvalid(true);
      isValid = false;
    }
    // if (dTFlag === false) {
    //   setDTFlagInvalid(true);
    //   isValid = false;
    // }
    return isValid;
  };

  const createBodyMask = () => {
    const mask = document.createElement('div');
    mask.id = 'global-mask';
    Object.assign(mask.style, {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      // backgroundColor: 'rgba(0,0,0,0.5)',
      backgroundColor: '#000000',
      opacity: '0.5',
      zIndex: 9999,
      pointerEvents: 'auto',
    });
    document.body.appendChild(mask);
    return mask;
  };

  const removeBodyChild = async () => {
    try {
      if (bodyMaskRef.current) {
        document.body.removeChild(bodyMaskRef.current);
      }
    } catch (error) {
      console.log('@@remove bodyMask error==>', error);
    }
  };

  const callbackTencent = async (res) => {
    console.log('@@callbackTencent==>', res);
    // res（fail）= {ret: 2, ticket: null}
    // res（success） = {ret: 0, ticket: "String", randstr: "String"}
    if (res.ret === 0) {
      bodyMaskRef.current = createBodyMask();
      // to get IP address
      const locationIp = await getLocationIP();
      if (locationIp) {
        const verifyStatus = await verifyTencent(locationIp, res.ticket, res.randstr);
        if (verifyStatus) {
          submitSubscription();
        } else {
          setErrorMsg(
            {
              sc: '验证失败',
              en: 'Verify Failure.',
              tc: '驗證失敗',
            }[curLang],
          );
          removeBodyChild();
        }
      } else {
        setErrorMsg(
          {
            sc: '获取地址失败.',
            en: 'Failed to get address.',
            tc: '獲取地址失敗.',
          }[curLang],
        );
        removeBodyChild();
      }
    } else if (res.ret === 2) {
      setIsClickConfirm(false);
    }
  };

  const callbackGoogle = async (response) => {
    console.log('@@callbackGoogle==>', response);
    bodyMaskRef.current = createBodyMask();
    const verifyStatus = await verifyGoogle(response);
    if (verifyStatus) {
      submitSubscription();
    } else {
      setErrorMsg(
        {
          sc: '验证失败',
          en: 'Verify Failure.',
          tc: '驗證失敗',
        }[curLang],
      );
      removeBodyChild();
    }
  };

  const captchaInit = async (locationCode) => {
    setErrorMsg('');
    // Captcha check
    if (locationCode === 'CHN') {
      try {
        const tencentCaptchaInstance = new window.TencentCaptcha(
          config.tencentCaptchaAppId,
          callbackTencent,
          { bizState: 'data-biz-state' },
        );

        // if (!tencentCaptchaInstance) return;
        tencentCaptchaInstance.show();
      } catch (error) {
        console.log('@@tencent captcha error==>', error);
        setIsClickConfirm(false);
      }
    } else {
      try {
        // const token = await window.grecaptcha.enterprise.execute(config.googleSitekey, {
        //   action: config.googleCaptchaAction,
        // });

        // callbackGoogle(token);

        window.grecaptcha.render(document.getElementById('captchaPopup'), {
          sitekey: config.googleSitekey,
          callback: callbackGoogle,
        });
      } catch (error) {
        console.log('@@google captcha error==>', error);
        setIsClickConfirm(false);
      }
    }
  };

  const submitSubscription = async () => {
    // submit
    const flagStatus = {
      true: 'Y',
      false: 'N',
      other: 'U',
    };
    const params = {
      email,
      salutation: 'Dr',
      firstname: firstName,
      lastname: lastName,
      countrycode,
      externalapp,
      language: curLang,
      DMFlag: 'U',
      DTFlag: flagStatus[dTFlag],
    };
    const result = await sendSubscription(params);
    console.log('@@email subscription response==>', JSON.stringify(result));
    if (result.data && result.data.subscribeResult === 0) {
      setIsSuccess(true);
    } else {
      setErrorMsg(
        {
          sc: '订阅提交失败',
          en: 'Subscription submission failed.',
          tc: '訂閲提交失敗',
        }[curLang],
      );
    }

    removeBodyChild();
  };

  const handleSubmitSubscription = async (event) => {
    try {
      //validation inputinput
      const isValid = validationInput();
      if (!isValid) {
        return false;
      }

      setIsClickConfirm(true);

      //get location code
      let locationCode = 'HKG';
      const result = await getLocationCode();
      if (result) {
        locationCode = result.countrySymbol;
      }
      //init captcha => verify
      captchaInit(locationCode);
    } catch (error) {
      console.log('@@email subscription error==>', error);
      setIsClickConfirm(false);
    }
  };

  const title = {
    sc: '时尚-订阅',
    en: 'Subscribe below for FASHIONALLY',
    tc: '時尚-訂閲',
  };

  return (
    <>
      <div id="emailSubWrapper">
        <Card className={`emailSubCard${isSuccess ? ' hidden' : ''}`}>
          <CardHeader>{title[curLang]}</CardHeader>
          <CardBody>
            {errorMsg && <div id="errorMsg">{errorMsg}</div>}
            <Form>
              <Row className="subInputBox">
                <Col xs={12} sm={12} md={12} lg={12}>
                  <FormGroup>
                    <Input
                      type="email"
                      placeholder={
                        {
                          sc: '邮箱..',
                          en: 'Email..',
                          tc: '郵箱..',
                        }[curLang]
                      }
                      id="emailAddressInput"
                      name="emailAddressInputName"
                      value={email}
                      onChange={handleEmailChange}
                      invalid={emailInvalid}
                      maxLength={30}
                      // style={{ textTransform: 'uppercase' }}
                    />
                    <FormFeedback>
                      {
                        {
                          sc: '请输入有效邮箱.',
                          en: 'Please input valid email.',
                          tc: '請輸入有效郵箱.',
                        }[curLang]
                      }
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <FormGroup>
                    <Input
                      type="text"
                      id="firstNameInput"
                      placeholder={
                        {
                          sc: '姓氏..',
                          en: 'First Name..',
                          tc: '姓氏..',
                        }[curLang]
                      }
                      value={firstName}
                      onChange={handleFirstNameChange}
                      invalid={firstNameInvalid}
                      maxLength={30}
                    />
                    <FormFeedback>
                      {
                        {
                          sc: '请输入姓氏.',
                          en: 'Please input First Name.',
                          tc: '請輸入姓氏.',
                        }[curLang]
                      }
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col xs={12} sm={6} md={6} lg={6}>
                  <FormGroup>
                    <Input
                      type="text"
                      id="lastNameInput"
                      placeholder={
                        {
                          sc: '名字..',
                          en: 'Last Name..',
                          tc: '名字..',
                        }[curLang]
                      }
                      value={lastName}
                      onChange={handleLastNameChange}
                      invalid={lastNameInvalid}
                      maxLength={30}
                    />
                    <FormFeedback>
                      {
                        {
                          sc: '请输入名字.',
                          en: 'Please input Last Name.',
                          tc: '請輸入名字.',
                        }[curLang]
                      }
                    </FormFeedback>
                  </FormGroup>
                </Col>
                <Col xs={12} sm={12} md={12} lg={12}>
                  <FormGroup>
                    <Input
                      type="select"
                      id="countrySelect"
                      name="countrySelectName"
                      value={countrycode}
                      onChange={handleCountryChange}
                      invalid={countryInvalid}
                      style={countrycode ? {} : { color: '#6c757d' }}
                    >
                      <option key="default-empty" value="" style={{ color: '#6c757d' }}>
                        {
                          {
                            sc: '国家/地区',
                            en: 'Country/Region',
                            tc: '國家/地區',
                          }[curLang]
                        }
                      </option>
                      {countryList.map((country) => (
                        <option
                          key={country.countryCode}
                          value={country.countryCode}
                          style={{ color: 'black' }}
                        >
                          {country[curLang]}
                        </option>
                      ))}
                    </Input>
                    <FormFeedback>
                      {
                        {
                          sc: '请选择国家/地区',
                          en: 'Please select Country/Region',
                          tc: '請選擇國家/地區',
                        }[curLang]
                      }
                    </FormFeedback>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
            <div
              className="check-txt"
              dangerouslySetInnerHTML={{
                __html: sanitizedHTML(
                  {
                    sc: `本人确定香港贸易发展局(“贸发局”)可将上述资料编入其全部或任何资料库内作为直接推广或商贸配对﹝因而可能成为可供本地及/或海外公众人士使用﹞，以及用于贸发局在<a href="https://home.hktdc.com/sc/s/privacy-policy-statement" target="_blank">私隐政策声明</a>中所述之其他用途;本人确认已获得此表格上所述的每一位人士同意及授权，将其个人资料提供予贸发局作此表格提及的用途。`,
                    en: `I acknowledge that the above information may be used by the Hong Kong Trade Development Council (HKTDC) for incorporation in all or any of its database for direct marketing or business matching purpose (and may therefore become available to the public within and/or outside of Hong Kong for use by them), and for any other purposes as stated in the <a href="https://home.hktdc.com/en/s/privacy-policy-statement" target="_blank">Privacy Policy Statement</a>; I confirm that I have the consent and the authority of each individual named in this form to release their personal data for the purposes stated herein.`,
                    tc: `本人確定香港貿易發展局(“貿發局”)可將上述資料編入其全部或任何資料庫內作為直接推廣或商貿配對﹝因而可能成為可供本地及/或海外公眾人士使用﹞，以及用於貿發局在<a href="https://home.hktdc.com/tc/s/privacy-policy-statement" target="_blank">私隱政策聲明</a>中所述之其他用途;本人確認已獲得此表格上所述的每一位人士同意及授權，將其個人資料提供予貿發局作此表格提及的用途。`,
                  }[curLang],
                ),
              }}
            ></div>
            <br />
          </CardBody>
          <CardFooter>
            <FormGroup check>
              <Input
                type="checkbox"
                checked={dTFlag}
                onChange={(e) => {
                  setDTFlag(e.target.checked);
                }}
              />
              <Label check>
                <div>
                  {
                    {
                      sc: '若阁下来自欧洲联盟(“欧盟”)或欧洲经济区的成员国，并同意我们将阁下的资料用作进行直接推广的用途，请于方格内加上✔号。',
                      en: '(If you are from a member state of the European Union (“EU”) / European Economic Area (“EEA”)), PLEASE tick here if you accept our use of your provided data for direct marketing purposes.',
                      tc: '若閣下來自歐洲聯盟(“歐盟”)或歐洲經濟區的成員國，並同意我們將閣下的資料用作進行直接推廣的用途，請於方格內加上✔號。',
                    }[curLang]
                  }
                </div>
              </Label>
            </FormGroup>
            <div className="explainTxt">
              {
                {
                  sc: '*此选项是按欧盟有关保护个人资料法律的要求而设，对于非欧盟/欧洲经济区的客户，请略过此项。',
                  en: '*For non-EU/EEA customers, please skip this box which is solely for EU/EEA customers as required by the relevant data protection law in the EU.',
                  tc: '*此選項是按歐盟有關保護個人資料法律的要求而設，對於非歐盟/歐洲經濟區的客戶，請略過此項。',
                }[curLang]
              }
            </div>
          </CardFooter>
          <div id="subEmailBtn">
            {/* <FontAwesomeIcon icon={faSpinner} spin /> */}
            {isClickConfirm ? null : (
              <span onClick={handleSubmitSubscription} style={{ cursor: 'pointer' }}>
                {
                  {
                    sc: '确定',
                    en: 'CONFIRM',
                    tc: '確定',
                  }[curLang]
                }
              </span>
            )}
            <div id="captchaPopup"></div>
          </div>
        </Card>
        {/* success */}
        <Card className={`emailSubSuccessCard${isSuccess ? ' show' : ''}`}>
          <div style={{ fontSize: '14px' }}>
            {
              {
                sc: '订阅成功',
                en: 'Subscribe successfully.',
                tc: '訂閲成功',
              }[curLang]
            }
          </div>
        </Card>
      </div>
    </>
  );
};

export default EmailSubscription;
